export enum ProductEnum {
  FinancialLeasing = "financial-leasing",
  Loa = "loa",
  Insurance = "insurance",
  Finance = "finance",
}

export enum ClientEnum {
  Business = "b2b",
  Private = "b2c"
}

export enum CarEnum {
  New = "new",
  Used = "used"
}

// At least one car type must stay enabled, or the funnel has nowhere to go.
export type EnabledCarTypes = readonly [CarEnum, ...CarEnum[]]

// Pre-owned financing is switched off at Polestar/KBC's request (KBC stopped the
// used-car widget). Add CarEnum.Used back here to offer it again.
export const ENABLED_CAR_TYPES: EnabledCarTypes = [CarEnum.New]

export enum BankEnum {
  KBC = "KBC",
  CBC = "CBC"
}
